import { useEffect } from 'react';
import { COMPANY } from '../config';

export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} | ${COMPANY.name}` : COMPANY.name;
    return () => { document.title = COMPANY.name; };
  }, [title]);
}
